import { IconTrash } from '@tabler/icons-react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogTrigger,
} from '../../atoms/alert-dialog'
import { FC, useCallback, useState } from 'react'
import Typography from 'src/components/atoms/Typography'
import { AlertDialogTitle } from '@radix-ui/react-alert-dialog'
import { IPaymentMethod, useDeletePaymentMethod } from 'src/enviroment/api/services/paymentMethodsApi'
import { enqueueSnackbar } from 'notistack'

interface Props {
  method: IPaymentMethod
}

const DeletePaymentDialog: FC<Props> = ({ method }) => {
  const { id, brand, last4 } = method
  const [opened, setOpened] = useState<boolean>(false)
  const { mutateAsync: deletePaymentMethod, isLoading: isDeleting } = useDeletePaymentMethod()
  const handleClose = useCallback(() => {
    setOpened(false)
  }, [])

  const handleDelete = useCallback(async () => {
    try {
      await deletePaymentMethod(id)
      handleClose()
    } catch (error) {
      enqueueSnackbar('An error occurred while deleting the payment method', { variant: 'error' })
    }
  }, [handleClose, id])

  return (
    <AlertDialog open={opened} onOpenChange={setOpened}>
      <AlertDialogTrigger className="flex h-10 w-10 items-center justify-center rounded-[8px] border border-red-ramo text-red-600 transition-all hover:cursor-pointer hover:bg-red-600 hover:text-white active:scale-95">
        <IconTrash size={24} />
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogTitle>
          <div className="flex flex-col items-center gap-4">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#FFADAD]">
              <IconTrash className="h-6 w-6 text-red-600" />
            </div>
            <div className="flex flex-col justify-center gap-6">
              <Typography variant="base" className="text-center text-green-50">
                Delete Payment Method
              </Typography>
              <Typography variant="base" className="text-center text-gray-50">
                You&apos;re about to delete the payment method {brand} **** **** **** {last4}. Are you sure you want to
                proceed?
              </Typography>
            </div>
          </div>
        </AlertDialogTitle>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={false} onClick={handleClose} className="w-40">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction disabled={isDeleting} onClick={handleDelete} className="w-40">
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default DeletePaymentDialog
